import Swiper from 'swiper'
import 'jquery-breakpoints'
//import redmore from 'readmore-js'

$(window).breakpoints({
	breakpoints: [
		{
			name: 'm',
			width: 768,
		},
		{
			name: 'l',
			width: 992,
		},
		{
			name: 'xl',
			width: 1024,
		},
		{
			name: 'xxl',
			width: 1280,
		},
	],
})
;(function ($) {
	$.fn.isOverflowHeight = function () {
		return this.each(function () {
			var el = $(this)
			if (el.css('overflow') == 'hidden') {
				var text = el.html()
				var t = $(this.cloneNode(true))
					.hide()
					.css('position', 'absolute')
					.css('overflow', 'visible')
					.height('auto')
					.width(el.width())
				el.after(t)
				alert(t.height() > el.height())
			}
		})
	}
})(jQuery)

$('.slider').each(function () {
	var slidesLength = $('.swiper-slide', this).length
	$(this).addClass('slider--with-' + slidesLength)
})

///STAGE
var sliderDirection = 'horizontal'
var stageSwipers = []

$('.slider--stage').each(function (index, el) {
	var currentSlider = $(this)

	if ($(this).hasClass('slider--1')) {
		sliderDirection = 'horizontal'
	}
	if ($(this).hasClass('slider--2')) {
		sliderDirection = 'vertical'
	}
	if ($(this).hasClass('slider--3')) {
		sliderDirection = 'vertical'
	}
	var mySwiper = new Swiper($(this), {
		loop: true,
		allowTouchMove: true,
		direction: 'horizontal',
		speed: 1500,

		pagination: {
			el: currentSlider.find('.swiper-pagination'),
			clickable: true,
		},

		breakpoints: {
			992: {
				allowTouchMove: false,
				direction: sliderDirection,
			},
		},
	})

	stageSwipers.push(mySwiper)
})

function autoPlaySlider() {
	if ($(window).width() >= 992) {
		$.each(stageSwipers, function (i, el) {
			el.slidePrev()
		})
		return
	}

	var mobileStageSlider = $('.slider--stage.slider--1')[0]

	if (mobileStageSlider && mobileStageSlider.swiper) {
		mobileStageSlider.swiper.slideNext()
	}
}

if ($('.slider--stage').length) {
	setInterval(autoPlaySlider, 10000)
}

///NAV
$('.slider--nav').each(function (index, el) {
	var currentSlider = $(this)

	var navSwiper = new Swiper($('.slider--nav__inner', this), {
		slidesPerView: 'auto',
		centeredSlides: false,
		loop: true,
		navigation: {
			nextEl: '.slider--nav .icon--arrow-slider--next',
			prevEl: '.slider--nav .icon--arrow-slider--prev',
		},
	})

	$('.nav--main .lvl-1 > a').click(function (e) {
		setTimeout(function () {
			navSwiper.update()
		}, 100)
	})
})

/// PRODUCTS
$('.slider--products').each(function (index, el) {
	var currentSlider = $(this)

	var produtsSwiper = new Swiper($(this), {
		slidesPerView: 'auto',
		centeredSlides: true,
		loop: false,
		pagination: {
			el: currentSlider.find('.swiper-pagination'),
			clickable: true,
		},

		navigation: {
			nextEl: currentSlider.next('.icon--arrow-slider--next'),
			prevEl: currentSlider.next().next('.icon--arrow-slider--prev'),
		},

		breakpoints: {
			// when window width is >= 992px
			992: {
				centeredSlides: false,
				loop: false,
			},
		},
	})
})

// PRODUCT DETAIL

var galleryThumbs = new Swiper('.gallery__thumbs', {
	direction: 'vertical',
	slidesPerView: 'auto',
	loop: false,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
})

$('.gallery').each(function () {
	var slidesLength = $('.gallery__full .swiper-slide', this).length
	$(this).addClass('slider--with-' + slidesLength)
})

var galleryFull = new Swiper('.gallery__full', {
	loop: true,
	pagination: {
		el: '.gallery .swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.section--gallery .icon--arrow-slider--next',
		prevEl: '.section--gallery .icon--arrow-slider--prev',
	},
	thumbs: {
		swiper: galleryThumbs,
	},
})

$('.gallery__full .gallery__toggle').click(function (event) {
	$('.section--gallery').toggleClass('fullwidth')
	$('.section--gallery').prev('section').toggleClass('hidden')
	galleryThumbs.update()
	galleryFull.update()
})

// TEASER
$('.slider--teaser').each(function (index, el) {
	var currentSlider = $(this)

	var teaserSwiper = new Swiper($(this), {
		slidesPerView: 1,
		autoHeight: true,
		loop: true,
		preventClicks: false,
		preventClicksPropagation: false,
		pagination: {
			el: currentSlider.find('.swiper-pagination'),
			clickable: true,
		},
		navigation: {
			nextEl: currentSlider.find('.icon--arrow-slider--next'),
			prevEl: currentSlider.find('.icon--arrow-slider--prev'),
		},
	})
})

var ID = function () {
	return '_' + Math.random().toString(36).substr(2, 9)
}

function updateControlSlides($controlEl, activeIndex) {
	if (!$controlEl || !$controlEl.length) return
	var $slides = $controlEl.find('.swiper-slide')
	var total = $slides.length
	if (total <= 5) return
	var half = 2
	var start = Math.max(0, Math.min(activeIndex - half, total - 5))
	$slides.each(function (i) {
		$(this).toggle(i >= start && i < start + 5)
	})
}

function scrollControlNav($controlEl, activeIndex) {
	if (!$controlEl || !$controlEl.length) return
	var $slides = $controlEl.find('.swiper-slide')
	var slideH = $slides.first().outerHeight(true) || 44
	var containerH = $controlEl.height() || slideH * 5
	var translateY = Math.max(0, activeIndex * slideH - containerH / 2 + slideH / 2)
	$controlEl.find('.swiper-wrapper').css('transform', 'translateY(-' + translateY + 'px)')
}

function initHistoryNav($nav) {
	// height controlled by CSS (fills .grid-cell-3)
}

function scrollHistoryNav($nav, $items, activeIndex) {
	var $inner = $nav.find('.history__nav__inner')
	if (!$inner.length) return
	var navH = $nav[0].offsetHeight
	if (!navH) return
	var itemH = $items.first().outerHeight(true) || 18.5
	var translateY = Math.max(0, activeIndex * itemH - navH / 2 + itemH / 2)
	$inner.css('transform', 'translateY(-' + translateY + 'px)')
}

// HISTORY
$('.teaser--history').each(function (index, el) {
	var historyID = ID()
	$(this).attr('id', historyID)

	var $controlEl = $('.slider--history--control', this)
	var $historyNav = $('.history__nav', el)
	var $historyNavItems = $historyNav.find('li')

	initHistoryNav($historyNav)

	var historySwiper = new Swiper($('.slider--history', this)[0] || $('.slider', this)[0], {
		slidesPerView: 1,
		direction: 'horizontal',
		autoHeight: true,
		allowTouchMove: true,
		touchStartPreventDefault: false,
		preventClicks: false,
		preventClicksPropagation: false,
		observer: true,
		observeParents: true,
		pagination: {
			el: '#' + historyID + ' .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '#' + historyID + ' .icon--arrow-slider--next',
			prevEl: '#' + historyID + ' .icon--arrow-slider--prev',
		},
		breakpoints: {
			992: {
				direction: 'vertical',
				autoHeight: false,
			},
		},
		on: {
			slideChange: function () {
				var idx = this.realIndex !== undefined ? this.realIndex : this.activeIndex
				$historyNavItems.removeClass('active')
				$historyNavItems.eq(idx).addClass('active')
				scrollHistoryNav($historyNav, $historyNavItems, idx)
				updateControlSlides($controlEl, idx)
			},
		},
	})

	// slider--history--control: click to navigate
	if ($controlEl.length) {
		$controlEl.find('.swiper-slide').each(function (i) {
			$(this).css('cursor', 'pointer').on('click', function () {
				historySwiper.slideTo(i)
			})
		})
	}

	$historyNavItems.click(function (event) {
		historySwiper.slideTo($(this).index())
	})

	// reset nav to slide 0 after all Swiper internal events have settled
	setTimeout(function () {
		if (historySwiper.activeIndex === 0) {
			$historyNavItems.removeClass('active')
			$historyNavItems.eq(0).addClass('active')
			scrollHistoryNav($historyNav, $historyNavItems, 0)
			updateControlSlides($controlEl, 0)
		}
	}, 100)
})

// MULTI

if ($('.slider--multi-wrapper').length) {
	const sliderBreakpoint = 1024
	const sliderBreakpointTablet = 1280

	$('.slider--multi-wrapper').wrapInner('<div class="inner"></div>')

	$(window).bind('breakpoint-change', function (e) {
		//console.log(e)
		location.reload()
	})

	var multiSlides = $('.slider--multi-wrapper > .inner > .swiper-slide')

	var slidesLength = multiSlides.length
	var slidesPerSwiper = Math.round(slidesLength / 4)

	var sliderIsTouchable = false
	var sliderDirection = 'vertical'

	if ($(window).width() <= sliderBreakpointTablet) {
		slidesPerSwiper = Math.round(slidesLength / 2)
		sliderIsTouchable = false
		sliderDirection = 'vertical'
	}

	if ($(window).width() < sliderBreakpoint) {
		slidesPerSwiper = slidesLength
		sliderIsTouchable = true
		sliderDirection = 'horizontal'
	}

	for (var i = 0; i < slidesLength; i += slidesPerSwiper) {
		multiSlides
			.slice(i, i + slidesPerSwiper)
			.wrapAll("<div class='slider slider--multi'><div class='swiper-wrapper'></div></div>")
	}

	var i = 0
	var multiSwipers = []

	$('.slider--multi').each(function (index, el) {
		i++
		if (i == 1) {
			var multiSwiper = new Swiper($(this), {
				slidesPerView: 1,
				autoHeight: true,
				direction: sliderDirection,
				loop: false,
				allowTouchMove: sliderIsTouchable,
				pagination: {
					el: '.slider--multi-wrapper .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.slider--multi-wrapper .icon--arrow-slider--next',
					prevEl: '.slider--multi-wrapper .icon--arrow-slider--prev',
				},
				on: {
					slideChangeTransitionStart: function (e) {
						playSliders(this.activeIndex)
					},
				},
			})

			multiSwipers.push(multiSwiper)
		} else {
			var multiSwiper = new Swiper($(this), {
				slidesPerView: 1,
				autoHeight: true,
				direction: 'vertical',
				loop: false,
				allowTouchMove: false,
			})

			multiSwipers.push(multiSwiper)
		}
	})

	var resizeTimer
	var contHeight = 0

	$(window).on('resize', function (e) {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(function () {
			if ($('.show-more-less').length) {
				$('.slider--multi .text').each(function () {
					var innerHeight = $(this).find('.ui-wrap').first().height()
					contHeight = $(this).innerHeight()

					$(this).data('height', contHeight)
					$(this).data('innerheight', innerHeight)
					if (innerHeight > contHeight) {
						$(this).find('.show-more-less').first().show()
						$(this).addClass('has-overflow')
					} else {
						$(this).find('.show-more-less').first().hide()
						$(this).removeClass('has-overflow')
					}
				})
			}
		}, 250)
	})

	if ($(window).width() > sliderBreakpoint) {
		if ($('.show-more-less').length) {
			$('.slider--multi .text').each(function () {
				var innerHeight = $(this).find('.ui-wrap').first().height()
				contHeight = $(this).innerHeight()

				$(this).data('height', contHeight)
				$(this).data('innerheight', innerHeight)
				if (innerHeight > contHeight) {
					$(this).find('.show-more-less').first().show()
				}
			})

			$('.show-more-less').click(function () {
				var parent = $(this).parent()
				if (parent.hasClass('open')) {
					parent.removeAttr('style')

					parent.removeClass('open')
				} else {
					parent.css('height', parent.data('innerheight') + 50)
					parent.addClass('open')
				}
			})
		}
	} else {
		if (innerHeight > contHeight) {
			$(this).find('.show-more-less').first().show()
			$(this).addClass('has-overflow')
		} else {
			$(this).find('.show-more-less').first().hide()
			$(this).removeClass('has-overflow')
		}
	}

	setTimeout(function () {
		window.dispatchEvent(new Event('resize'))
	}, 500)
	setTimeout(function () {
		window.dispatchEvent(new Event('resize'))
	}, 1000)

	function playSliders(index) {
		var time = 150

		$.each(multiSwipers, function (i, el) {
			setTimeout(function () {
				el.slideTo(index)
			}, time / 2)
			time += 150
		})
	}
}
